/**
 * AAA IDP delivery pick up store reducer
 * 
 */
import { DELETE, DELIVERY_PICK_UP_STORE, DELIVERY_PICK_UP_STORE_REQUIRED_ATTRIBUTE } from '../../actions/types';
export const initialState = {
  error: false,
  required: false,
  valid: null,
  value: 0
};
export default function (state = initialState, action) {
  switch (action.type) {
    case DELETE:
      return initialState;
    case DELIVERY_PICK_UP_STORE:
      {
        const {
          value
        } = action;
        const valid = Number.isInteger(value) && value > 0 ? true : false;
        return {
          ...state,
          error: !valid,
          value,
          valid
        };
      }
    case DELIVERY_PICK_UP_STORE_REQUIRED_ATTRIBUTE:
      {
        const {
          required
        } = action;
        return {
          ...state,
          error: false,
          required: required,
          valid: true
        };
      }
    default:
      return state;
  }
}